import { Text } from "recharts";

type CustomizedPieLabelProps = {
  cx: number;
  cy: number;
  midAngle: number;
  outerRadius: number;
  percent: number;
  index: number;
  colors: string[];
};

export const CustomizedPieLabel = ({ cx, cy, midAngle, outerRadius, percent, index, colors }: CustomizedPieLabelProps) => {
  const RADIAN = Math.PI / 180;

  const radius = outerRadius + 30;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  const lineX = cx + outerRadius * Math.cos(-midAngle * RADIAN);
  const lineY = cy + outerRadius * Math.sin(-midAngle * RADIAN);

  if (percent * 100 < 1) return null;

  return (
    <>
      <line x1={lineX} y1={lineY} x2={x} y2={y} stroke={colors[index]} strokeWidth={1.5} />
      <Text x={x} y={y} fill="#595959" textAnchor={x > cx ? "start" : "end"} dominantBaseline="middle">
        {(percent * 100).toFixed(0) + "%"}
      </Text>
    </>
  );
};
